<template>
    <g class="logo">
        <path class="path-1" d="M336.32,117.13q.75,0,1.5,0a38.45,38.45,0,1,1-26.47,66.23s-2.37-2.43-3.44-3.75" />
        <path class="path-3" d="M309.47,183.51c-.47,0-1,0-1.42,0a38.43,38.43,0,1,1,0-76.85,37.69,37.69,0,0,1,26.3,10.55s2.59,2.64,3.74,4.11" />
        <path class="path-2 stroke-salmon" d="M311.33,177.44a31.36,31.36,0,0,1-3.51.19,32.54,32.54,0,1,1,24.33-54.22s2.15,2.63,3.06,4.07" />
        <path class="path-4 stroke-salmon" d="M334.16,123.21c.74-.09,1.49-.15,2.24-.19.53,0,1.06,0,1.6,0a32.57,32.57,0,1,1-24.39,54.14h0a33.44,33.44,0,0,1-2.72-3.53" />
        <g style="clip-path: url(#a);">
        <path class="path-5 stroke-pink" d="M325.42,125.55c-4.42-2.67-9.52-6-17.85-6A25.56,25.56,0,0,0,282.08,145c0,14.89,11.8,25,23.76,25,3.13,0,9.77-1.34,15-3s10.38-8.07,12.21-16.7H312c1.83-8.64,9.15-15.64,17.3-18.62A25.49,25.49,0,1,1,338,181.15c-9.19,0-16.9-3.92-21.39-11.22" style="stroke-width: 10px"/>
        </g>
    </g>
</template>

<script>
export default {
  name: "Logo"
}
</script>

<style lang="less">
</style>